export default "__VITE_ASSET__DvJIv_e2__"